import { PickupInfoList } from '@/types/api/v1/PickUpInfoResponse';
import { atom } from 'recoil';
import persistAtom from './recoilPersist';
export type PickUpReferenceInfoStateType = {
  // 集荷先情報の取得
  pickupInfoList: PickupInfoList[];
};
export const PickUpReferenceInfoState = atom<PickUpReferenceInfoStateType>({
  key: 'PickUpReferenceInfoState',
  default: {
    // 集荷先情報の取得
    pickupInfoList: []
  },
  effects_UNSTABLE: [persistAtom]
});
export default PickUpReferenceInfoState;